import axios from "axios";
import { toast } from "react-toastify"; // Assuming toast notifications are handled by react-toastify
import { retrieveToken } from "../utils/cryptoStorage";

const LOCATION_API_URL = import.meta.env.VITE_API_URL_COUNSILOR;

// Axios instance configuration
const counsilorAxiosInstance = axios.create({
  baseURL: LOCATION_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add Authorization token dynamically
counsilorAxiosInstance.interceptors.request.use(
  async (config) => {
    const token = retrieveToken("accessToken"); // Fetch token dynamically for each request
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // Optionally, you can handle the absence of the token more gracefully
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

counsilorAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 403 ||
      error.response?.status === 401
    ) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Centralized error handling (excluding 403 and network errors)

const handleError = (error) => {
  if (error.response) {
    const { status, data } = error.response;
    if (data && data.message) {
      toast.error(data.message);
    }
    switch (status) {
      case 500:
        throw new Error("Server Error (500): Please try again later.");
      case 422:
        throw new Error("Validation Error (422): Check your input.");
      case 401:
        localStorage.clear();
        window.location.href = "/login";
        throw new Error("Unauthorized (401): Please log in.");
      default:
        throw new Error(`Unexpected API Error: ${status}`);
    }
  } else {
    throw new Error("Network Error or Server Unreachable.");
  }
};

// API method to fetch
export const fetchCounsilors = async (params) => {
  try {
    const response = await counsilorAxiosInstance.get(`/admin-councilors/v1`, {
      params,
    });
    return response.data.data;
  } catch (error) {
    handleError(error);
  }
};

export const modifyCounsilors = async (data) => {
  try {
    const response = await counsilorAxiosInstance.post(
      `/admin-councilors/v1`,
      data
    );
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateCounsilors = async (data) => {
  try {
    const response = await counsilorAxiosInstance.post(
      `/admin-councilor-qualification/v1`,
      data
    );
    return response.data;
  } catch (error) {
    // handleError(error);
  }
};

//wards
export const fetchWards = async (params) => {
  try {
    const response = await counsilorAxiosInstance.get(`/ward-list/v1`, {
      params,
    });
    return response.data.data;
  } catch (error) {
    // handleError(error);
  }
};

export const fetchCounsilorsById = async (params) => {
  try {
    const response = await counsilorAxiosInstance.get(`/admin-councilors/v1`, {
      params,
    });
    return response.data.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateCounsilorImage = async (data) => {
  try {
    // Use the axios instance to make the GET request with the parameters
    const response = await counsilorAxiosInstance.put(
      "/councilor-image-update/v1",
      data
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const changeCounsilor = async (data) => {
  try {
    // Use the axios instance to make the GET request with the parameters
    const response = await counsilorAxiosInstance.post(
      "/change-councilors/v1",
      data
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const fetchProject = async (params) => {
  try {
    // Use the axios instance to make the GET request with the parameters
    const response = await counsilorAxiosInstance.get("/projects/v1", {
      params,
    });
    return response?.data?.data;
  } catch (error) {
    handleError(error);
  }
};

//ward approvel
export const fetchCouncilorReqList = async (params) => {
  try {
    const response = await counsilorAxiosInstance.get(
      `/change-councilor-request-lists/v1`,
      {
        params,
      }
    );
    return response.data.data;
  } catch (error) {
    // handleError(error);
  }
};

export const fetchPrevCounsilor = async (params) => {
  try {
    // Use the axios instance to make the GET request with the parameters
    const response = await counsilorAxiosInstance.get(
      "/admin-previous-councilors/v1",
      {
        params,
      }
    );
    return response?.data.data;
  } catch (error) {
    handleError(error);
  }
};

export const modifyProject = async (data) => {
  try {
    // Use the axios instance to make the GET request with the parameters
    const response = await counsilorAxiosInstance.post("/projects/v1", data);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const changeProjectStatus = async (data) => {
  try {
    // Use the axios instance to make the GET request with the parameters
    const response = await counsilorAxiosInstance.put(
      "/project-status-update/v1",
      data
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
